<div #chartdiv [attr.id]="id" class="chartdiv"></div>